class RecentlyViewed extends HTMLElement {  
    constructor() {
        super();
        this.searchTerm = this.getQuery();
        this.container = this.querySelector('ul.row');
    }

    getQuery() {
        let recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
        let recentlyViewedString = recentlyViewed.map(item => `"${item}"`).join(' OR ');
        return recentlyViewedString;

        }

    connectedCallback() {

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          const originalH2 = this.querySelector('.title-wrapper h2');
          console.log(`${routes.predictive_search_url}?q=${encodeURIComponent(this.searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[options][fields]')}=title&section_id=recently-viewed`);
    
          fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(this.searchTerm)}&${encodeURIComponent('resources[type]')}=product&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[options][fields]')}=title&section_id=recently-viewed`)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const results = html.querySelector('recently-viewed .inner');
            
                // Check if results exist and it's not empty
                if (results && results.innerHTML.trim().length) {
                  const newH2 = results.querySelector('.title-wrapper h2');
                  if (originalH2 && newH2) {
                    newH2.replaceWith(originalH2);
                  }
                  // Parse the recently viewed items from local storage
                  const recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed')) || [];
            
                  // Select the product list container and the individual product elements
                  const productList = results.querySelector('.slider');
                  const productItems = Array.from(productList.querySelectorAll('.slider__slide'));
            
                  // Sort the product items based on the order in recentlyViewed
                  const sortedProductItems = productItems.sort((a, b) => {
                    const titleA = a.dataset.title;
                    const titleB = b.dataset.title;
                    return recentlyViewed.indexOf(titleA) - recentlyViewed.indexOf(titleB);
                  });
            
                  // Remove all product items from the container
                  productItems.forEach(item => productList.removeChild(item));
            
                  // Append sorted product items back into the container
                  sortedProductItems.forEach(item => productList.appendChild(item));
            
                  this.innerHTML = results.outerHTML;
                }
                observer.disconnect();
              })
            
            .catch(e => {
              console.error(e);
            });
        }
    
        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
      }
  

  
  }
  
  customElements.define('recently-viewed', RecentlyViewed);
  